import { mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { InstancePositions } from '@paragon/production-app-utilities';

import { getProductionComponentInstancesByBundleGuid } from './getProductionComponentInstancesByBundleGuid';

export const getInstancePositionsByBundleGuid = createSelector(
  getProductionComponentInstancesByBundleGuid,

  (productionComponentInstancesByBundleGuid) =>
    mapValues(productionComponentInstancesByBundleGuid, (productionComponentInstancesForBundle) =>
      productionComponentInstancesForBundle.reduce((accumulator, instance) => {
        const { bundlePositionX, bundlePositionY } = instance;
        if (bundlePositionX === null || bundlePositionY === null) throw new Error('Position in bundle not set');
        accumulator[instance.guid] = {
          x: bundlePositionX,
          y: bundlePositionY,
        };
        return accumulator;
      }, {} as InstancePositions),
    ),
);
